import { getPlatformUrlParts } from '@acl-services/highbond-common';

const {
  protocol,
  orgSubdomain,
  domain,
  region,
  domainSuffix,
  tld,
  isLocal,
  isDev,
  isStaging,
  isPreprod,
  isProduction,
  isGovCloud,
} = getPlatformUrlParts(window.location.origin, true);

const isLocalhost = isLocal || process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
const nonUsRegionalSuffix = region !== 'us' ? `-${region}` : '';

const host = `${domain}${domainSuffix}.${tld}`;

const AppConfig = {
  homeUrl: `${protocol}://${orgSubdomain}.home${nonUsRegionalSuffix}.${host}`,
  launchpadUrl: `${protocol}://accounts.${host}`,
  loginUrl: `${protocol}://accounts.${host}/login`,
  oidcClientUrl: isLocalhost ? 'http://localhost:5173' : `${protocol}://oidc-${region}.${host}`,
  organizationsApiUrl: `${protocol}://organizations.${host}`,
  pendoMonitorScript: `${protocol}://monitor${nonUsRegionalSuffix}.${host}/v1/monitor.js`,
  isLocal,
  isDev,
  isStaging,
  isProduction,
  isProductionLike: isProduction || isPreprod,
  isGovCloud,
  region,
  orgSubdomain: isLocal ? 'test-org' : orgSubdomain,
  microFrontends: {
    'hb-global-navigator': {
      url: `${protocol}://web-components${nonUsRegionalSuffix}.${host}/global-navigator/index.js`,
    },
  },
  featureFlags: {
    placeholder: {
      enabled: false,
    },
    aiSettings: {
      enabled: !(isProduction || isPreprod) && !isGovCloud,
    },
  },
  // Sidecar auth configuration
  // Enabled in environments where the OIDC client and proxy sidecars are deployed.
  // Currently only enabled in dev environments. Update this as sidecar is rolled out to staging/prod.
  // Disabled in GovCloud (no sidecar infrastructure) and localhost (local development).
  sidecarAuthEnabled: isDev && !isGovCloud && !isLocalhost,
  sessionEndpoint: '/apis/oidc/userinfo',
  oidcAuthStartEndpointPath: '/oidc/start',
  proxyApiEndpoints: {
    accounts: {
      proxyPathPrefix: '/apis/accounts',
      oidcResourceIndicator: `https://accounts.${host}`,
    },
    organizations: {
      proxyPathPrefix: '/apis/organizations',
      oidcResourceIndicator: `https://organizations.${host}`,
    },
    monitor: {
      proxyPathPrefix: '/apis/monitor',
      oidcResourceIndicator: `https://monitor${nonUsRegionalSuffix}.${host}`,
    },
    activity: {
      proxyPathPrefix: '/apis/activity',
      oidcResourceIndicator: `https://activity-api${nonUsRegionalSuffix}.${host}`,
    },
  },
  pendoMonitorProxyScript: '/apis/monitor/v1/monitor.js',
};

export default AppConfig;

export const AppRoutes = {
  ROOT_PATH: 'security-settings',
  AI_SETTINGS: 'ai-settings',
  UNAUTHORIZED: 'unauthorized',
  OIDC_CALLBACK: 'oidc/callback',
  LOGOUT_CALLBACK: 'logout',
  LOGIN_CALLBACK: 'login/callback',
};

export const PendoTracking = {
  NEW_USER_INVITATION_EXPIRY: 'organization-settings_new-user-invitation-expiry',
};
